module.exports = __webpack_public_path__ + "static/media/s97ga01.6e30afc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/sgal/s97ga01.jpg
// module id = 266
// module chunks = 0